/**
 * <LessonFloat
      lesson={lesson}
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import Float from 'components/UI/Float';
import './LessonFloat.scss';
import moment from 'moment';
import { Button } from 'components/UI';
import AttendanceModal from 'template/Modals/Attendance';
import UpdateLesson from 'template/Docks/UpdateLesson';
import __R, { userCan } from 'containers/__R';
import getLessonAttendance from 'controllers/lesson/getLessonAttendance'
import isEmpty from 'lodash/isEmpty';

class LessonFloat extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);

    this.state = {
      studentAmount: '',
      teacherList: [],
      studentList: [],
    }

    this.renderFloatContent = this.renderFloatContent.bind(this);
  }

  componentDidMount() {
  }

  componentWillReceiveProps(nextProps){
    if(!isEmpty(nextProps.lesson) && nextProps.lesson!== null){
      getLessonAttendance(nextProps.lesson.id)
      .then((res) => {
        this.setState({
          studentAmount: res.student_amount,
          teacherList: res.teacher_list,
          studentList: res.student_list
        })
      })
      .catch((err) => {console.log(err)})
    }
  }

  render() {
    const {
      show,
      target,
      lesson,
      onCloseFloat,
    } = this.props;

    return (
      <Float
        container={global['--classtop-main-section']}
        show={show}
        target={target}
        floatWidth={400}
        onCloseFloat={onCloseFloat}
      >
        {this.renderFloatContent()}
      </Float>
    )
  }

  renderFloatContent() {
    const {
      onCloseFloat,
      onChange,
      lesson,
    } = this.props;

    if (!lesson) {
      return <div />
    }

    const {teacherList, studentList, studentAmount} = this.state;

    const {
      calendarColor,
      title,
      classroomName,
      startTime,
      endTime,
      id,
      classId,
      status,
      classType,
    } = lesson;

    const startTimeStr = moment(startTime).format('HH:mm a');
    const endTimeStr = moment(endTime).format('HH:mm a');

    let teacherNames = [];
    if (teacherList) {
      teacherNames = teacherList.map((teacher)=>{
        return teacher.teacher_name;
      });
    }

    return (
      <div className='lesson-detail-float'>
        <div className='title-section' style={{backgroundColor: calendarColor, }}>
          {title}
          <i
            className='fa icon-cancel'
            style={{WebkitTextStrokeColor: calendarColor}}
            onClick={onCloseFloat}
          />
        </div>
        <div className='detail-section'>
          <dl><dt>{__('Start Time', 'LessonFloat')}</dt><dd>{startTimeStr}</dd></dl>
          <dl><dt>{__('End Time', 'LessonFloat')}</dt><dd>{endTimeStr}</dd></dl>
          <dl><dt>{__('Number of Student', 'LessonFloat')}</dt><dd>{studentAmount}</dd></dl>
          { classroomName && <dl><dt>{__('Classroom', 'LessonFloat')}</dt><dd>{classroomName}</dd></dl> }
          { teacherNames.length > 0 && <dl><dt>{__('Teacher', 'LessonFloat')}</dt><dd>{teacherNames.join(', ')}</dd></dl> }
          <div className='controller-section'>
            <__R can='manually_check_in' by='disable' tooltipPosition='left'>
              <Button bsStyle='default' onClick={(e)=>{
                AttendanceModal({ lessonId: id, classId })
                .then((a)=>{
                  onChange(a)
                });
                onCloseFloat();
              }}>{__('Attendance', 'LessonFloat')}</Button>
            </__R>
            { ((classType == 0 && userCan('edit_lesson')) || (classType == 1 && userCan('edit_private_lesson'))) &&
              <Button bsStyle='default' disabled={status == 1 ? true : false} onClick={()=>{
                UpdateLesson({ lesson, classId: lesson.classId, studentList, teacherList })
                .then((res) => { onChange(res) })
                onCloseFloat();
              }}>{__('Edit', 'LessonFloat')}</Button>
            }
          </div>
        </div>
      </div>
    );
  }

}

export default LessonFloat;



// WEBPACK FOOTER //
// ./src/template/Floats/LessonFloat/index.js